import { StatusTypes, UserTypes } from 'types/GlobalTypes';

import { TypeColorsDictionary } from './Constants';

/**
 * @param type: type
 * @returns 'color
 */

export const getColor = (type: UserTypes | StatusTypes | null) => TypeColorsDictionary[type?.toLowerCase() || 'Other'];
